"use strict";

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var Typography_1 = require("./Typography");

var styled_components_1 = __importStar(require("styled-components"));

var styled_component_helpers_1 = require("./styled-component-helpers");

var Link = function Link(props) {
  var children = props.children,
      other = __rest(props, ["children"]);

  return React.createElement(exports.LinkStyled, __assign({}, other), children);
};

Link.defaultProps = {
  url: ""
};
exports["default"] = Link;
exports.LinkAttrs = {
  href: function href(props) {
    if (!props.url) {
      if (props.href) {
        console.error("use url prop instead of href");
      }

      return undefined;
    } else if (typeof props.url === "string" && (props.url.startsWith("http") || !props.url.startsWith("www"))) {
      return props.url;
    } else {
      return "http://" + props.url;
    }
  },
  target: function target(props) {
    if (!props.url) {
      if (props.href) {
        console.error("use url prop instead of href");
      }

      return undefined;
    } else {
      return props.blank ? "_blank" : "_self";
    }
  },
  rel: function rel(props) {
    return !props.url ? undefined : "noopener noreferrer";
  }
};
exports.LinkStyled = styled_components_1["default"](Typography_1.Par.textAction.withComponent("a")).attrs(function (props) {
  return exports.LinkAttrs;
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-decoration: none;\n  color: ", ";\n  .hasHover &:hover {\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n  }\n  // Additional props when the child is of type string\n  ", "\n"], ["\n  text-decoration: none;\n  color: ", ";\n  .hasHover &:hover {\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n  }\n  // Additional props when the child is of type string\n  ", "\n"])), styled_component_helpers_1.theme("link.normal"), styled_component_helpers_1.theme("link.hover"), styled_component_helpers_1.theme("link.active"), function (props) {
  return typeof props.children === "string" && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-bottom: 1px solid ", ";\n      padding-bottom: 1px; // Makes it 4px from baseline\n      .hasHover &:hover {\n        border-bottom: 2px solid ", ";\n      }\n      &:active {\n        border-bottom: 3px solid ", ";\n      }\n    "], ["\n      border-bottom: 1px solid ", ";\n      padding-bottom: 1px; // Makes it 4px from baseline\n      .hasHover &:hover {\n        border-bottom: 2px solid ", ";\n      }\n      &:active {\n        border-bottom: 3px solid ", ";\n      }\n    "])), styled_component_helpers_1.theme("link.border"), styled_component_helpers_1.theme("link.hover"), styled_component_helpers_1.theme("link.active"));
});
var templateObject_1, templateObject_2;